import { HierarchyContextProps, IHierarchyActionSetSaveTocRequestStatus } from "../interface";

/**
 * Updates the ToC major-version save request status.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-save-toc-request-status action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchySaveTocRequestStatus = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetSaveTocRequestStatus,
): HierarchyContextProps => ({
  ...state,
  saveTocRequestStatus: action.saveTocRequestStatus,
});
